module.exports = __webpack_public_path__ + "static/media/ehealth_minor_redemption_banner_desktop.6a0c0116.jpg";